import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import classNames from 'classnames';

import { IconAdd } from '../../../data/assets/icons';

class AddInputItem extends React.PureComponent {
    renderInputField = () => {
        const { size, input_type, placeholder, value, onChange, disabled, onKeyDown } = this.props;
        if (input_type === 'textarea') {
            return (
                <Input.TextArea className="ori-r-pad-40 ori-font-xs" placeholder={placeholder} autosize={{ minRows: 2, maxRows: 3 }} value={value} onChange={onChange} disabled={disabled} onKeyDown={onKeyDown} />
            );
        }
        return (
            <Input className="ori-lr-pad-40 ori-border-radius-3" size={size} placeholder={placeholder} value={value} onChange={onChange} disabled={disabled} onKeyDown={onKeyDown} />
        );
    }

    render() {
        const { title, input_type, size, container_class, show_add_btn, onClickBtn, disabled } = this.props;

        return (
            <div className={`${container_class}`}>
                {
                    title &&
                    <p className="ori-b-mrgn-5 ori-capitalize-first">{title}</p>
                }
                <div className="ori-relative ori-tb-mrgn-5" >
                    {this.renderInputField()}
                    {
                        input_type !== 'textarea' &&
                        <div className={classNames("ori-absolute ori-align-top ori-align-left ori-flex ori-lr-pad-10", { "ori-font-light": disabled, "ori-font-primary": !disabled, "ori-t-pad-10": size === 'large', "ori-t-pad-6": size === 'default' })}>
                            <IconAdd size={19} />
                        </div>
                    }
                    {
                        show_add_btn &&
                        <div className="ori-absolute ori-animated ori-zoom-in ori-cursor-ptr ori-align-top ori-align-right ori-pad-10 ori-font-primary ori-font-sm" onClick={onClickBtn}>
                            <span>Add</span>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

AddInputItem.propTypes = {
    title: PropTypes.string,
    size: PropTypes.oneOf(['small', 'default', 'large']),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    container_class: PropTypes.string,
    input_type: PropTypes.string,
    show_add_btn: PropTypes.bool,
    onClickBtn: PropTypes.func,
    onKeyDown: PropTypes.func,
    disabled: PropTypes.bool,
};

AddInputItem.defaultProps = {
    size: "large",
    input_type: "input",
    placeholder: "Add new item",
    show_add_btn: false,
    disabled: false
};

export default AddInputItem;



// WEBPACK FOOTER //
// ./src/components/form/addinputItem/index.js